import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { TABLE_HEADER_BG } from "./constants";

const DataTable = ({
  columns = [],
  children,
  emptyMessage = "No data found",
  isEmpty = false,
  stickyHeader = true,
}) => (
  <Paper
    elevation={0}
    className="data-table-card"
    sx={{
      border: "1px solid #eee",
      borderRadius: "12px",
      overflow: "hidden",
      bgcolor: "transparent",
    }}
  >
    <TableContainer>
      <Table stickyHeader={stickyHeader} aria-label="data table">
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell
                key={col.id}
                align={col.align || "left"}
                sx={{
                  bgcolor: TABLE_HEADER_BG,
                  color: "#666",
                  fontWeight: 600,
                  fontSize: "0.8rem",
                  borderBottom: "1px solid #eee",
                  whiteSpace: "nowrap",
                  minWidth: col.minWidth,
                }}
              >
                <Typography
                  component="span"
                  variant="body2"
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.5,
                    fontWeight: 600,
                    color: "#666",
                  }}
                >
                  {col.label}
                  {col.sortable && (
                    <UnfoldMoreIcon sx={{ fontSize: 16, color: "#bbb" }} />
                  )}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        {isEmpty ? (
          <TableBody>
            <TableRow className="data-table-row">
              <TableCell
                colSpan={columns.length || 1}
                align="center"
                sx={{ py: 4, bgcolor: "transparent" }}
              >
                <Typography color="text.secondary">{emptyMessage}</Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          children
        )}
      </Table>
    </TableContainer>
  </Paper>
);

export const DataTableRow = ({ children, hover = true, ...props }) => (
  <TableRow
    hover={hover}
    className="data-table-row"
    sx={{
      bgcolor: "transparent",
      "&:last-child td": { borderBottom: 0 },
      "& td": {
        borderBottom: "1px solid #f0f0f0",
        fontSize: "0.85rem",
        py: 1.5,
        bgcolor: "transparent",
      },
    }}
    {...props}
  >
    {children}
  </TableRow>
);

export const DataTableCell = ({ children, ...props }) => (
  <TableCell {...props}>{children}</TableCell>
);

export default DataTable;
